// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IEoyPlanReconciliationApproveDto,
  IEoyPlanReconciliationResponseDto,
  IErrorDto,
  IGenericErrorDto,
  IPrefundReturnApproveDto,
  IPrefundReturnResponseDto,
} from '../models/index';
import {
    IEoyPlanReconciliationApproveDtoFromJSON,
    IEoyPlanReconciliationApproveDtoToJSON,
    IEoyPlanReconciliationResponseDtoFromJSON,
    IEoyPlanReconciliationResponseDtoToJSON,
    IErrorDtoFromJSON,
    IErrorDtoToJSON,
    IGenericErrorDtoFromJSON,
    IGenericErrorDtoToJSON,
    IPrefundReturnApproveDtoFromJSON,
    IPrefundReturnApproveDtoToJSON,
    IPrefundReturnResponseDtoFromJSON,
    IPrefundReturnResponseDtoToJSON,
} from '../models/index';

export interface ApproveEoyPlanReconciliationRequest {
    iEoyPlanReconciliationApproveDto: IEoyPlanReconciliationApproveDto;
}

export interface ApprovePrefundReturnRequest {
    iPrefundReturnApproveDto: IPrefundReturnApproveDto;
}

export interface GetEoyPlanReconciliationByInvoiceId1Request {
    invoiceId: number;
}

export interface GetPrefundReturnByInvoiceId1Request {
    invoiceId: number;
}

export interface RepullPrefundWorkflowRequest {
    invoiceId: number;
}

export interface ResumeReplenishmentRejectWorkflowRequest {
    invoiceId: number;
}

/**
 * ReplenishmentServiceServiceApi - interface
 * 
 * @export
 * @interface ReplenishmentServiceServiceApiInterface
 */
export interface ReplenishmentServiceServiceApiInterface {
    /**
     * 
     * @summary Approve EOY plan reconciliation
     * @param {IEoyPlanReconciliationApproveDto} iEoyPlanReconciliationApproveDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReplenishmentServiceServiceApiInterface
     */
    approveEoyPlanReconciliationRaw(requestParameters: ApproveEoyPlanReconciliationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Approve EOY plan reconciliation
     */
    approveEoyPlanReconciliation(requestParameters: ApproveEoyPlanReconciliationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Approve prefund return
     * @param {IPrefundReturnApproveDto} iPrefundReturnApproveDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReplenishmentServiceServiceApiInterface
     */
    approvePrefundReturnRaw(requestParameters: ApprovePrefundReturnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Approve prefund return
     */
    approvePrefundReturn(requestParameters: ApprovePrefundReturnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get EOY plan reconciliation by invoiceId
     * @param {number} invoiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReplenishmentServiceServiceApiInterface
     */
    getEoyPlanReconciliationByInvoiceId1Raw(requestParameters: GetEoyPlanReconciliationByInvoiceId1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEoyPlanReconciliationResponseDto>>;

    /**
     * Get EOY plan reconciliation by invoiceId
     */
    getEoyPlanReconciliationByInvoiceId1(requestParameters: GetEoyPlanReconciliationByInvoiceId1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEoyPlanReconciliationResponseDto>;

    /**
     * 
     * @summary Get prefund return by invoice id
     * @param {number} invoiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReplenishmentServiceServiceApiInterface
     */
    getPrefundReturnByInvoiceId1Raw(requestParameters: GetPrefundReturnByInvoiceId1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPrefundReturnResponseDto>>;

    /**
     * Get prefund return by invoice id
     */
    getPrefundReturnByInvoiceId1(requestParameters: GetPrefundReturnByInvoiceId1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPrefundReturnResponseDto>;

    /**
     * 
     * @summary Repull prefund workflow by invoice id
     * @param {number} invoiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReplenishmentServiceServiceApiInterface
     */
    repullPrefundWorkflowRaw(requestParameters: RepullPrefundWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Repull prefund workflow by invoice id
     */
    repullPrefundWorkflow(requestParameters: RepullPrefundWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Resume replenishment reject workflow by invoice id
     * @param {number} invoiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReplenishmentServiceServiceApiInterface
     */
    resumeReplenishmentRejectWorkflowRaw(requestParameters: ResumeReplenishmentRejectWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>>;

    /**
     * Resume replenishment reject workflow by invoice id
     */
    resumeReplenishmentRejectWorkflow(requestParameters: ResumeReplenishmentRejectWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number>;

}

/**
 * 
 */
export class ReplenishmentServiceServiceApi extends runtime.BaseAPI implements ReplenishmentServiceServiceApiInterface {

    /**
     * Approve EOY plan reconciliation
     */
    async approveEoyPlanReconciliationRaw(requestParameters: ApproveEoyPlanReconciliationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iEoyPlanReconciliationApproveDto'] == null) {
            throw new runtime.RequiredError(
                'iEoyPlanReconciliationApproveDto',
                'Required parameter "iEoyPlanReconciliationApproveDto" was null or undefined when calling approveEoyPlanReconciliation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/eoy-plan-reconciliations/approve`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IEoyPlanReconciliationApproveDtoToJSON(requestParameters['iEoyPlanReconciliationApproveDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Approve EOY plan reconciliation
     */
    async approveEoyPlanReconciliation(requestParameters: ApproveEoyPlanReconciliationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.approveEoyPlanReconciliationRaw(requestParameters, initOverrides);
    }

    /**
     * Approve prefund return
     */
    async approvePrefundReturnRaw(requestParameters: ApprovePrefundReturnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iPrefundReturnApproveDto'] == null) {
            throw new runtime.RequiredError(
                'iPrefundReturnApproveDto',
                'Required parameter "iPrefundReturnApproveDto" was null or undefined when calling approvePrefundReturn().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/prefund-returns/approve`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IPrefundReturnApproveDtoToJSON(requestParameters['iPrefundReturnApproveDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Approve prefund return
     */
    async approvePrefundReturn(requestParameters: ApprovePrefundReturnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.approvePrefundReturnRaw(requestParameters, initOverrides);
    }

    /**
     * Get EOY plan reconciliation by invoiceId
     */
    async getEoyPlanReconciliationByInvoiceId1Raw(requestParameters: GetEoyPlanReconciliationByInvoiceId1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEoyPlanReconciliationResponseDto>> {
        if (requestParameters['invoiceId'] == null) {
            throw new runtime.RequiredError(
                'invoiceId',
                'Required parameter "invoiceId" was null or undefined when calling getEoyPlanReconciliationByInvoiceId1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/eoy-plan-reconciliations/invoices/{invoice_id}`;
        urlPath = urlPath.replace(`{${"invoice_id"}}`, encodeURIComponent(String(requestParameters['invoiceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEoyPlanReconciliationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get EOY plan reconciliation by invoiceId
     */
    async getEoyPlanReconciliationByInvoiceId1(requestParameters: GetEoyPlanReconciliationByInvoiceId1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEoyPlanReconciliationResponseDto> {
        const response = await this.getEoyPlanReconciliationByInvoiceId1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get prefund return by invoice id
     */
    async getPrefundReturnByInvoiceId1Raw(requestParameters: GetPrefundReturnByInvoiceId1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPrefundReturnResponseDto>> {
        if (requestParameters['invoiceId'] == null) {
            throw new runtime.RequiredError(
                'invoiceId',
                'Required parameter "invoiceId" was null or undefined when calling getPrefundReturnByInvoiceId1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/prefund-returns/invoices/{invoice_id}`;
        urlPath = urlPath.replace(`{${"invoice_id"}}`, encodeURIComponent(String(requestParameters['invoiceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPrefundReturnResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get prefund return by invoice id
     */
    async getPrefundReturnByInvoiceId1(requestParameters: GetPrefundReturnByInvoiceId1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPrefundReturnResponseDto> {
        const response = await this.getPrefundReturnByInvoiceId1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Repull prefund workflow by invoice id
     */
    async repullPrefundWorkflowRaw(requestParameters: RepullPrefundWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['invoiceId'] == null) {
            throw new runtime.RequiredError(
                'invoiceId',
                'Required parameter "invoiceId" was null or undefined when calling repullPrefundWorkflow().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/prefund-histories/invoices/{invoice-id}/repull`;
        urlPath = urlPath.replace(`{${"invoice-id"}}`, encodeURIComponent(String(requestParameters['invoiceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Repull prefund workflow by invoice id
     */
    async repullPrefundWorkflow(requestParameters: RepullPrefundWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.repullPrefundWorkflowRaw(requestParameters, initOverrides);
    }

    /**
     * Resume replenishment reject workflow by invoice id
     */
    async resumeReplenishmentRejectWorkflowRaw(requestParameters: ResumeReplenishmentRejectWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['invoiceId'] == null) {
            throw new runtime.RequiredError(
                'invoiceId',
                'Required parameter "invoiceId" was null or undefined when calling resumeReplenishmentRejectWorkflow().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/prefund-histories/invoices/{invoice-id}/resume/replenishment/reject`;
        urlPath = urlPath.replace(`{${"invoice-id"}}`, encodeURIComponent(String(requestParameters['invoiceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Resume replenishment reject workflow by invoice id
     */
    async resumeReplenishmentRejectWorkflow(requestParameters: ResumeReplenishmentRejectWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.resumeReplenishmentRejectWorkflowRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
